export default "assets/logo-47b14e57.svg";